import React from 'react';

const ANIMATIONS = [
  { value: 'none', label: 'None', icon: '—' },
  { value: 'bounce', label: 'Bounce', icon: '🏀' },
  { value: 'fade', label: 'Fade In', icon: '✨' },
  { value: 'slide', label: 'Slide In', icon: '→' },
  { value: 'pulse', label: 'Pulse', icon: '💓' },
  { value: 'glow', label: 'Glow', icon: '💡' },
  { value: 'typewriter', label: 'Typewriter', icon: '⌨' },
];

export default function AnimationPanel({ value, onChange }) {
  return (
    <div>
      <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Animation</h3>
      <div className="space-y-1">
        {ANIMATIONS.map(a => (
          <button
            key={a.value}
            onClick={() => onChange(a.value)}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-xs transition-colors ${
              value === a.value
                ? 'bg-purple-100 text-purple-700 border border-purple-300 font-medium'
                : 'hover:bg-gray-50 text-gray-700 border border-transparent'
            }`}
          >
            <span className="w-5 text-center">{a.icon}</span>
            <span>{a.label}</span>
            {value === a.value && <span className="ml-auto text-purple-500">✓</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
